"use strict";
// 保存依赖信息的meta的key值
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_CONSTRUCTOR = exports.PROPS_DEPS = exports.CLASS_CONSTRUCTOR_DEPS = void 0;
exports.CLASS_CONSTRUCTOR_DEPS = 'di:ctor_deps';
exports.PROPS_DEPS = 'di:props_deps';
exports.POST_CONSTRUCTOR = 'di:post_constructor';
//# sourceMappingURL=metadata-keys.js.map